const ACTION_TYPES = {
  SET_CITIES: "setCities",
  SET_PROVINCE: "setProvince",
};

const locationReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_CITIES:
      const { cities } = action.payload;
      return {
        cities,
      };

    case ACTION_TYPES.SET_PROVINCE:
      const { province } = action.payload;
      return {
        province,
      };

    default:
      return state;
  }
};

export default locationReducer;
